import React from 'react';
import { NavLink } from "react-router-dom";
import SimpleLightbox from 'simple-lightbox';
export class Tile extends React.Component {

	handleLightbox(e) {

		e.preventDefault();

		SimpleLightbox.open({
			items: [this.props.url]
		});
	}

	render() {

        const style = this.props.bg ? {backgroundImage: `url(${this.props.bg})`} : {};
		if(this.props.transparent) style.backgroundColor = 'transparent';
        //const target = this.props.target ? '_blank' : '';

		if(this.props.target === '_blank') {
			return (
				<a href={this.props.url} target="_blank" rel="noopener noreferrer"
				onClick={(e) => {this.props.lightbox && this.handleLightbox(e)}}
	        	 className="tile" style={style}>
				 	{this.props.children}
	        	</a>
			);
		} else if(this.props.url) {
			return (
				<NavLink to={this.props.url} activeClassName="active"
	        	 className="tile" style={style}>
					{this.props.children}
	        	</NavLink>
			);
		} else {
			return (
				<div className="tile" style={style}>
					{this.props.children}
	        	</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/chunk/Tile.js